const AboutPage = () => {
    return (
        <>
            <section className="text-white p-20">
                <h1 className="text-3xl font-bold mb-6 text-center">About</h1>
                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">Our Story</h2>
                    <p className="mb-4">
                        Welcome to [Your Company Name], a team of passionate artists and creatives dedicated to bringing
                        your visions to life. We believe in the power of art to inspire, communicate, and transform. Our
                        journey began [Year Started] with a simple idea: to provide exceptional artistic services that
                        exceed expectations.
                    </p>
                    <p className="mb-4">
                        From our humble beginnings, we have grown into a dynamic team with a diverse range of skills and
                        expertise. We've worked on projects ranging from [mention some project types, e.g., digital
                        illustrations, concept art, graphic design, etc.], always striving for excellence and
                        innovation.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
                    <p className="mb-4">
                        Our mission is to [state your company's mission, e.g., provide high-quality, creative solutions
                        that
                        help our clients achieve their goals]. We are committed to fostering a collaborative environment
                        where creativity flourishes and clients feel valued.
                    </p>
                    <p className="mb-4">
                        We value [mention your company values, e.g., integrity, creativity, collaboration, excellence].
                        These values guide our work and drive us to deliver exceptional results.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">Our Team</h2>
                    <p className="mb-4">
                        Our team consists of talented artists, designers, and creative professionals with a wide range
                        of
                        backgrounds and expertise. We are passionate about what we do and are committed to continuous
                        learning and improvement.
                    </p>
                    <p className="mb-4">
                        [Optional: You can include short bios or photos of key team members here.]
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">Our Approach</h2>
                    <p className="mb-4">
                        We believe in a collaborative approach to every project. We work closely with our clients to
                        understand their needs and goals, ensuring that the final product exceeds their expectations.
                    </p>
                    <p className="mb-4">
                        Our process involves [describe your process, e.g., initial consultation, concept development,
                        revisions, final delivery]. We are committed to clear communication and transparency throughout
                        the
                        entire process.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
                    <p className="mb-4">
                        We'd love to hear from you! If you have any questions or would like to discuss a project, please
                        contact us at:
                    </p>
                    <p>
                        Email: <a href="mailto:[Your Contact Email]">[Your Contact Email]</a><br/>
                        Phone: [Your Phone Number (Optional)]<br/>
                        Address: [Your Company Address (Optional)]
                    </p>
                </section>
            </section>
        </>
    )
}

export default AboutPage;
